"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreToken = exports.InjectStore = exports.createCAStore = void 0;
const redux_1 = require("redux");
require("reflect-metadata");
const typedi_1 = require("typedi");
function createCAStore() {
    const store = Object.assign((0, redux_1.createStore)((state = {}) => state, {}), {
        /**
         * Object with reducers injected to the store
         *
         * @private
         */
        reducers: {},
        /**
         * Injects passed reducer to the store
         *
         * @param newReducers - reducers to inject
         */
        injectReducers: (newReducers) => {
            store.reducers = Object.assign(Object.assign({}, store.reducers), newReducers);
            store.replaceReducer((0, redux_1.combineReducers)(store.reducers));
        },
        /**
         * Removes reducer from the store
         * @param name — name of reducer to remove
         */
        removeReducer: (name) => {
            delete store.reducers[name];
            if (Object.keys(store.reducers).length === 0) {
                store.replaceReducer(() => ({}));
                return;
            }
            store.replaceReducer((0, redux_1.combineReducers)(store.reducers));
        },
    });
    return store;
}
exports.createCAStore = createCAStore;
const store = createCAStore();
var InjectStore_1 = require("./InjectStore");
Object.defineProperty(exports, "InjectStore", { enumerable: true, get: function () { return InjectStore_1.InjectStore; } });
//@todo replace storage usage with the new decorator
exports.default = store;
exports.StoreToken = new typedi_1.Token('STORE');
typedi_1.Container.set(exports.StoreToken, store);
